export interface TraceEntry {
  id: string
  timestamp: number
  persisted?: boolean
}

export interface TraceBufferConfig {
  maxSize: number
  ttlMs?: number
}

class TraceBuffer {
  private buffer: (TraceEntry | null)[]
  private size: number = 0
  private head: number = 0
  private maxSize: number
  private seen: Set<string>
  private ttlMs: number

  constructor(config: TraceBufferConfig = { maxSize: 20000 }) {
    this.maxSize = config.maxSize
    this.ttlMs = config.ttlMs ?? 24 * 60 * 60 * 1000
    this.buffer = new Array(this.maxSize).fill(null)
    this.seen = new Set<string>()
  }

  add(traceId: string): void {
    if (this.seen.has(traceId)) return

    const entry: TraceEntry = {
      id: traceId,
      timestamp: Date.now(),
    }

    this.buffer[this.head] = entry
    this.head = (this.head + 1) % this.maxSize

    if (this.size < this.maxSize) {
      this.size++
    }

    this.seen.add(traceId)

    if (this.seen.size > this.maxSize) {
      const oldest = this.buffer[this.head]?.id
      if (oldest) {
        this.seen.delete(oldest)
      }
    }
  }

  getAll(): TraceEntry[] {
    return this.buffer.filter((item): item is TraceEntry => item !== null)
  }

  getSize(): number {
    return this.size
  }

  // Ring buffer автоматически перезаписывает старые записи при достижении maxSize (НО НЕ ОЧИЩАЕТ ИХ СО ВРЕМЕНЕМ!!!!)
  clear(): void {
    this.buffer = new Array(this.maxSize).fill(null)
    this.size = 0
    this.head = 0
    this.seen.clear()
  }
}

export const traceBuffer = new TraceBuffer({ maxSize: 20000 })
